/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Authprovider1Inputs */

const en_entity_authprovider1 = /** @type {(inputs: Entity_Authprovider1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auth Provider`)
};

const de_entity_authprovider1 = /** @type {(inputs: Entity_Authprovider1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Authentifizierungsanbieter`)
};

/**
* | output |
* | --- |
* | "Auth Provider" |
*
* @param {Entity_Authprovider1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_authprovider1 = /** @type {((inputs?: Entity_Authprovider1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Authprovider1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_authprovider1(inputs)
	return de_entity_authprovider1(inputs)
});
export { entity_authprovider1 as "entity_authProvider" }